import { useMemo } from "react";

import { useWorkspaceContext } from "src/router/routerContextHooks";

export const useIsModuleEnabled = (kind: string): { isEnabled: boolean } => {
  const { modules } = useWorkspaceContext();

  const isEnabled = useMemo(
    () => modules?.some((m) => m.kind === kind && m.spec !== null) ?? false,
    [modules, kind],
  );

  return { isEnabled };
};
